import I18n from 'I18n';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { PricePerMonth } from 'pricing-pages-ui-components/price/PricePerMonth';
import { useDisplayedCurrencyCode } from '../../../hooks/useCurrencies';
import { usePurchaseOptionsForProductsForTerm } from '../../../hooks/usePurchaseOptions';
import { useAppSelector } from '../../../reducers';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { useQueryParamTerm } from '../../../utils/urls/appQueryParamUtils';
import SkeletonLoadWrapper from '../../common/loading/SkeletonLoadWrapper';
import { MicroCopy } from '../price-display/PriceStyledComponents';
import { useShowPricePerMonthPerSeat } from '../seats-display/useSeatsDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UnlockHubSpotCreditsInfo = ({
  seleniumId,
  hubSpotCreditsProduct,
  unlockHubSpotCreditsProductConfigurations,
  unlockHubSpotCreditsSkuId
}) => {
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const UNLOCK_COPY = {
    CUSTOMER_AGENT: isAppAuth ? I18n.text('merchCards.hubSpotCredits.CUSTOMER_AGENT.unlock') : I18n.text('merchCards.hubSpotCredits.CUSTOMER_AGENT.unlockWithProOrEnt'),
    BREEZE: I18n.text('merchCards.hubSpotCredits.BREEZE.unlock')
  };
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const currencyCode = useDisplayedCurrencyCode();
  const {
    pricingData,
    loading: priceLoading
  } = usePurchaseOptionsForProductsForTerm({
    term: queryParamTerm,
    productConfigurations: unlockHubSpotCreditsProductConfigurations
  });
  const price = pricingData === null || pricingData === void 0 ? void 0 : pricingData.monthly.calculatedPrice;
  const showPricePerMonthPerSeat = useShowPricePerMonthPerSeat({
    skuId: unlockHubSpotCreditsSkuId
  });

  // On public page, hide price for customer agent page.
  // It should be a generic "Unlock Breeze Customer Agent with a Professional or Enterprise plan"
  const hidePrice = !isAppAuth && hubSpotCreditsProduct === 'CUSTOMER_AGENT';
  return /*#__PURE__*/_jsxs(Flex, {
    backgroundColor: "fill-surface-raised",
    padding: "300",
    flexDirection: "column",
    gap: "0",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "span",
      typography: "heading-50",
      children: UNLOCK_COPY[hubSpotCreditsProduct]
    }), hidePrice ? null : /*#__PURE__*/_jsx(MicroCopy, {
      use: "help",
      children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: priceLoading,
        widths: ['50%'],
        heights: [20],
        children: price ? /*#__PURE__*/_jsx(PricePerMonth, {
          price: price,
          currencyCode: currencyCode,
          showPricePerMonthPerSeat: showPricePerMonthPerSeat,
          seleniumId: seleniumId
        }) : null
      })
    })]
  });
};
export default UnlockHubSpotCreditsInfo;